import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const WelcomeStep = ({ email, onNext }) => {
  return (
    <div className="space-y-6">
      {/* Welcome Header */}
      <div className="text-center space-y-3">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto">
          <Icon name="UserCheck" size={32} className="text-primary" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground">
          Welcome to RVS Gallery Platform
        </h2>
        <p className="text-muted-foreground max-w-xl mx-auto">
          You've been invited as a contributor. Let's set up your account to start managing galleries.
        </p>
      </div>

      {/* Account Information */}
      <div className="bg-muted/50 rounded-lg p-6 space-y-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="Info" size={20} className="text-primary" />
          Your Account Information
        </h3>
        <div className="space-y-3">
          <div className="flex items-start gap-3">
            <Icon name="Mail" size={18} className="text-muted-foreground mt-0.5" />
            <div>
              <p className="text-sm font-medium text-foreground">Email Address</p>
              <p className="text-sm text-muted-foreground">{email}</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Icon name="Shield" size={18} className="text-muted-foreground mt-0.5" />
            <div>
              <p className="text-sm font-medium text-foreground">Role</p>
              <p className="text-sm text-muted-foreground">Contributor</p>
            </div>
          </div>
        </div>
      </div>

      {/* What You'll Do */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-foreground">What You'll Do Next</h3>
        <div className="space-y-3">
          <div className="flex items-start gap-3">
            <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-xs font-bold text-primary">1</span>
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Create Your Password</p>
              <p className="text-xs text-muted-foreground">Set a secure password for your account</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-xs font-bold text-primary">2</span>
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Confirm Your Role</p>
              <p className="text-xs text-muted-foreground">Review your permissions and responsibilities</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-xs font-bold text-primary">3</span>
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Start Managing Galleries</p>
              <p className="text-xs text-muted-foreground">Access your dashboard and begin creating galleries</p>
            </div>
          </div>
        </div>
      </div>

      {/* Action Button */}
      <div className="pt-4">
        <Button
          onClick={onNext}
          variant="default"
          size="lg"
          className="w-full"
          iconName="ArrowRight"
          iconPosition="right"
        >
          Get Started
        </Button>
      </div>
    </div>
  );
};

export default WelcomeStep;